module.exports = __webpack_public_path__ + "static/alte-haas-bold-2c2eabbd0151a452c9a8a4cd4341edc4.ttf";